import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ControlWrapper from "./o2-control-wrapper";

function O2TextField(props) {
  var children = props.children,
      id = props.id,
      block = props.block,
      wrapperId = props.wrapperId,
      className = props.className,
      label = props.label,
      inline = props.inline,
      inlineVertical = props.inlineVertical,
      inlineLabel = props.inlineLabel,
      indentLeft = props.indentLeft,
      indentRight = props.indentRight,
      indentBottom = props.indentBottom,
      fakeLabel = props.fakeLabel,
      validationText = props.validationText,
      validationType = props.validationType,
      note = props.note,
      labelNote = props.labelNote,
      wrapperModifiers = props.wrapperModifiers,
      wrapperClassName = props.wrapperClassName,
      controlSize = props.controlSize,
      big = props.big,
      mobileFull = props.mobileFull,
      inputType = props.inputType,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "id", "block", "wrapperId", "className", "label", "inline", "inlineVertical", "inlineLabel", "indentLeft", "indentRight", "indentBottom", "fakeLabel", "validationText", "validationType", "note", "labelNote", "wrapperModifiers", "wrapperClassName", "controlSize", "big", "mobileFull", "inputType"]);

  var inputClasses = classNames("o2-control__input", className, validationType ? "o2-control__validation--" + validationType : false, controlSize ? "o2-control--" + controlSize : false, {
    "o2-control__input--big": big,
    "o2-control--mobile-full": mobileFull
  });
  var content;
  var btnLeft;
  var btnOverInner;
  var btnRight;

  if (!children) {
    content = /*#__PURE__*/React.createElement("input", _extends({
      id: id,
      className: inputClasses
    }, attributes));
  } else {
    var btnLeftAddon;
    var input;
    var btnRightAddon;
    React.Children.forEach(children, function (child) {
      if (child.type === "input") {
        input = /*#__PURE__*/React.createElement("input", _extends({
          id: id,
          className: inputClasses
        }, attributes));
      } else {
        if (child.type.displayName !== "O2Button") {
          console.log(child.type);
          throw new Error("Component should only contain buttons and input");
        } else if (!input && !btnLeft) {
          btnLeft = child;
        } else if (!input) {
          btnLeftAddon = child;
        } else if (child.props.form === "over-inner") {
          btnOverInner = child;
        } else if (!btnRight) {
          btnRight = child;
        } else {
          btnRightAddon = btnRight;
          btnRight = child;
        }
      }
    });

    if (!input) {
      throw new Error("Input not found");
    }

    content = /*#__PURE__*/React.createElement(React.Fragment, null, btnLeft, btnLeftAddon, /*#__PURE__*/React.createElement("div", {
      className: "o2-control__inner-container"
    }, input, btnOverInner), btnRightAddon, btnRight);
  }

  return /*#__PURE__*/React.createElement(ControlWrapper, {
    id: wrapperId,
    controlId: id,
    note: note,
    block: block,
    label: label,
    labelNote: labelNote,
    inline: inline,
    inlineVertical: inlineVertical,
    inlineLabel: inlineLabel,
    wrapperModifiers: wrapperModifiers,
    validationType: validationType,
    validationText: validationText,
    wrapperClassName: wrapperClassName,
    btnLeft: btnLeft != null,
    btnRight: btnRight != null,
    btnOver: btnOverInner != null,
    indentLeft: indentLeft,
    indentRight: indentRight,
    indentBottom: indentBottom,
    fakeLabel: fakeLabel,
    inputType: inputType
  }, content);
}

O2TextField.propTypes = {
  id: PropTypes.string,
  wrapperId: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["md"])]),
  inlineVertical: PropTypes.oneOf(["top", "middle", "bottom"]),
  inlineLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["lg"])]),
  indentLeft: PropTypes.bool,
  indentRight: PropTypes.bool,
  indentBottom: PropTypes.bool,
  fakeLabel: PropTypes.bool,
  validationText: PropTypes.string,
  validationType: PropTypes.oneOf(["error", "warning", "success", false]),
  note: PropTypes.string,
  labelNote: PropTypes.string,
  wrapperModifiers: PropTypes.string,
  wrapperClassName: PropTypes.string,
  controlSize: PropTypes.oneOf(["xs", "date", "small", "medium", "large", "xlarge", "full-width", "auto-width", "mobile-full"]),
  big: PropTypes.bool,
  mobileFull: PropTypes.bool,
  inputType: PropTypes.oneOf(["filter", "combobox"]),
  block: PropTypes.bool
};
export default O2TextField;